<template>
  <div style=" background-color: #F5F6FA;">
    <hear></hear>
    <BDhear :num="6"></BDhear>
    <div class="content" style="background-color: #fff;">
      <div
        class="content_form"
        style="width:70%; border:1px solid #ccc; height:200px; margin-top:50px;"
      >
        <div>对公账号信息</div>
        <div class="form_box">
          <el-form
            :disabled="true"
            :model="show_formInline"
            label-width="100px"
            class="demo-form-inline"
          >
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="银行名称">
                  <el-input v-model="show_formInline.bankname" placeholder="审批人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行卡号">
                  <el-input v-model="show_formInline.bankcode" placeholder="审批人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行账号">
                  <el-input v-model="show_formInline.bankaccount" placeholder="审批人"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="content_bottom">
        <div>打款人账户信息</div>
        {{formInline}}
        <div class="form_box">
          <el-form :model="formInline" label-width="100px" class="demo-form-inline">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="银行名称">
                  <el-input v-model="formInline.bankname" placeholder="审批人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行卡号">
                  <el-input v-model="formInline.bankcode" placeholder="审批人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行账号">
                  <el-input v-model="formInline.bankaccount" placeholder="审批人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="支付凭证">
                  <el-upload
                    name="image"
                    class="avatar-uploader"
                    action="https://agent.hnzyxsbh.com/api/baohan/upload"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="button_sub" style="margin:20px 0px;">
        <!-- <el-button type="primary" plain>s</el-button> -->
        <el-button @click="submit()" type="primary">提交</el-button>
        <el-button @click="shengchengbaohan" type="info">生成保函</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getpayinfo } from "@/api/system/liucheng";
import hear from ".././../components/hear.vue";
import BDhear from "./BDhear.vue";
import axios from "axios";
export default {
  components: {
    hear,
    BDhear
  },
  name: "ElectronicSignature",
  data() {
    return {
      dialogVisible: false,
      imageUrl: "",
      espdfstatusList: [{}, {}, {}],
      formInline: {
        user_id: sessionStorage.getItem("user_id"),
        guarantee_comid: sessionStorage.getItem("guarantee_comid"),
        guarantee_apply_id: sessionStorage.getItem("guarantee_apply_id")
      },
      show_formInline: {},
      bh_id: sessionStorage.getItem("guarantee_apply_id"),
      params: {
        guarantee_apply_id: sessionStorage.getItem("guarantee_apply_id"),
        user_id: sessionStorage.getItem("user_id")
      }
    };
  },
  mounted() {
    this.get_detail();
  },
  methods: {
    Bidpayment() {
      this.$router.push("/Bidpayment");
    },
    shengchengbaohan() {
      axios({
        url: "https://api.hnzyxsbh.com/mobile/agent/baohan/bhfiles_create",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          guarantee_apply_id:sessionStorage.getItem('guarantee_apply_id')
        },
        timeout: 1000,
        headers: {
          token: sessionStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 1) {
          this.$message.success("提交成功等待审核");
          // this.isShow = false;
        }
        // this.$router.push("/BidSecurity/Bidpayment");
      });
    },
    submit() {
      axios({
        url: "https://api.hnzyxsbh.com/mobile/agent/baohan/zfbank",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: this.formInline,
        timeout: 1000,
        headers: {
          token: sessionStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 1) {
          this.$message.success("提交成功等待审核");
          // this.isShow = false;
        }
        // this.$router.push("/BidSecurity/Bidpayment");
      });
    },

    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res.data);
      this.formInline.zfimage = res.data;
      this.imageUrl = this.$baseUrl + res.data;
    },
    beforeAvatarUpload() {},
    get_detail() {
      getpayinfo(this.params).then(res => {
        this.show_formInline = res.data.data.info;
      });
    }
  }
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  border: 1px solid #ccc;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ES_BTN {
  position: relative;
  left: 66%;
  top: 17%;
}

.EP_footer_box {
  position: relative;
  left: 22%;
  top: 10%;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.content_form {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.form_box {
  width: 80%;
  margin: 0 auto;
}
.content_bottom {
  width: 70%;
  border: 1px solid #ccc;
  margin-top: 30px;
}
.EP_details_rigth {
  width: 436px;
  height: 4px;
  background: linear-gradient(259deg, #fafafa 0%, #4f7e8d 100%);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
}

.EP_details_left {
  width: 436px;
  height: 4px;
  background: linear-gradient(90deg, #fafafa 0%, #4f7e8d 100%);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
}

.EP_details_information {
  width: 974px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ES_PDF_IMG {
  display: flex;
  align-items: center;
}

.ES_pdf_status {
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ES_hear_box_status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.ES_HEAR_PDF_BOX {
  width: 884px;
  height: 80px;
  border: 1px solid #cecece;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ES_hear_box {
  width: 971px;
  position: relative;
  left: 26%;
  top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/view/BidSecurity/ElectronicSignature.vue